import { Link } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';

export default function NotFound() {
  return (
    <PageWrapper>
      <div className="empty" style={{ minHeight: '70vh' }}>
        <div className="empty__icon" style={{ fontSize: 72 }}>404</div>
        <h2>Page not found</h2>
        <p>The page you're looking for doesn't exist.</p>
        <Link to="/" className="btn btn-primary mt-2">Back home</Link>
      </div>
    </PageWrapper>
  );
}
